<template>
    <div class="footer">
        <div class="footerCon">
            <div class="erweima">
                <img src="../assets/img/erweima.png" alt="">
            </div>
            <div class="footerP">
                <h3>{{$t('footer.title')}}</h3>
                <p>{{$t('footer.tel')}}:010-84846461</p>
                <p>{{$t('footer.address')}}</p>
                <p>
                    <span style="margin-right:40px;display: inline-block;">
                        {{$t('footer.web')}}:http://www.hexishuzi.com</span>
                    <span>{{$t('footer.postcode')}}:100012</span>
                </p>
                <p>{{$t('footer.beian')}}</p>
                <p class="last-child">
                    <img src="../assets/img/beian.png" alt="">
                    <span>{{$t('footer.beian')}}</span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
               
            }
        },
        methods: {
            
        },
        computed: {
            
        },
    }
</script>

<style scoped lang="scss">
.footer{
   background-color: #555;
   padding-top:50px ;
    padding-bottom:50px ;
}
.footerCon{
    width: 1200px;
    margin: 0 auto;
    display: flex;
    .erweima{
        margin-right: 50px;
        img{
            width: 160px;
        }
    } 
    .footerP{
        color:#f5f5f5;
        h3{
            margin-bottom: 10px;
        }
        p{
            line-height: 26px;
            position: relative;
        }
        p.last-child{
            img{
               float: left;
               margin-top:2px;
            }
        }
    }
 }  
 
</style>